export default "__VITE_ASSET__Dt20sNeW__"